import jobVSwork  from './jobvswork.json'; 
import frequency  from './frequency.json';
import phrasal  from './phrasal.json';
import adjectives  from './adjectives.json';
import presentcontinuous  from './presentcontinuous2.json';
import collocations  from './collocations.json';
import phrasal2  from './phrasal2.json';
import modifyers  from './modifyers.json';
import ingEd  from './ing-ed.json';
import did from './did.json';
import prefix from './prefix.json';


export const GRAMMAR_M7 = [
  ...jobVSwork,
  ...frequency,
  ...phrasal,
  ...adjectives,
  ...presentcontinuous,
  ...collocations,
  ...phrasal2,
  ...modifyers,
  ...ingEd,
  ...did,
  ...prefix,
];